namespace GeniuzPOS.Member {
    export interface MbReport_01_Dt_Row {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        LineItemType?: string;
        ItemDesc?: string;
        RefLineItemNo?: number;
        PosFg?: number;
        PluCode?: string;
        SellUnit?: string;
        Qty?: number;
        SerialNo?: string;
        UnitPrice?: number;
        ExPrice?: number;
        DiscPc?: number;
        Discamt?: number;
        DiscCouponType?: string;
        DiscCouponNo?: string;
        PromoId?: string;
        ChargePc?: number;
        ChargeAmt?: number;
        ItemVatType?: string;
        ItemPromoFg?: number;
        ItemPromoId?: string;
        ItemDiscount?: number;
        ItemCharge?: number;
        ItemNetExprice?: number;
        AllocatedBillDiscount?: number;
        ItemNetSales?: number;
        ItemVatRate?: number;
        ItemVat?: number;
        QtyRefund?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace MbReport_01_Dt_Row {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'Member.MbReport_01_Dt_';
        export const deletePermission = '3Member:สถานะสมาชิก:View';
        export const insertPermission = '3Member:สถานะสมาชิก:View';
        export const readPermission = '3Member:สถานะสมาชิก:View';
        export const updatePermission = '3Member:สถานะสมาชิก:View';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            LineItemType = "LineItemType",
            ItemDesc = "ItemDesc",
            RefLineItemNo = "RefLineItemNo",
            PosFg = "PosFg",
            PluCode = "PluCode",
            SellUnit = "SellUnit",
            Qty = "Qty",
            SerialNo = "SerialNo",
            UnitPrice = "UnitPrice",
            ExPrice = "ExPrice",
            DiscPc = "DiscPc",
            Discamt = "Discamt",
            DiscCouponType = "DiscCouponType",
            DiscCouponNo = "DiscCouponNo",
            PromoId = "PromoId",
            ChargePc = "ChargePc",
            ChargeAmt = "ChargeAmt",
            ItemVatType = "ItemVatType",
            ItemPromoFg = "ItemPromoFg",
            ItemPromoId = "ItemPromoId",
            ItemDiscount = "ItemDiscount",
            ItemCharge = "ItemCharge",
            ItemNetExprice = "ItemNetExprice",
            AllocatedBillDiscount = "AllocatedBillDiscount",
            ItemNetSales = "ItemNetSales",
            ItemVatRate = "ItemVatRate",
            ItemVat = "ItemVat",
            QtyRefund = "QtyRefund",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
